<template>
    <div class="feature-review-container">
        <v-row>
            <v-col class="card-container">
                <v-card tile :elevation="messagesExist ? 12 : 2">
                    <v-row class="mx-0">
                        <v-col cols="auto" class="card-information-container">
                            <v-card-title>
                                {{configurationWrapper.value}}
                            </v-card-title>
                            <v-card-subtitle class="card-subtitle">
                                {{configurationName}}
                            </v-card-subtitle>
                        </v-col>
                        <v-spacer/>
                        <v-col cols="auto" class="card-state-container" :class="configurationWrapper.state">
                            {{configurationWrapper.state}}
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <MessageWrapper :messageWrapper="configurationWrapper.messages" />
    </div>
</template>

<script>
    import MessageWrapper from "./MessageWrapper";

    export default {
        name: 'FeatureReview',
        components: {
            MessageWrapper: MessageWrapper
        },
        props: [
            'configurationWrapper',
            'configurationName'
        ],
        computed: {
            successMessagesExist: function () {
                return this.configurationWrapper.messages.SUCCESS && this.configurationWrapper.messages.SUCCESS.length > 0;
            },
            successMessages: function () {
                if (this.successMessagesExist) {
                    return this.configurationWrapper.messages.SUCCESS.messages;
                } else {
                    return [];
                }
            },
            needsConfirmationMessagesExist: function () {
                return this.configurationWrapper.messages.NEEDS_CONFIRMATION && this.configurationWrapper.messages.NEEDS_CONFIRMATION.length > 0;
            },
            needsConfirmationMessages: function () {
                if (this.needsConfirmationMessagesExist) {
                    return this.configurationWrapper.messages.NEEDS_CONFIRMATION.messages;
                } else {
                    return [];
                }
            },
            errorMessagesExist: function () {
                return this.configurationWrapper.messages.ERROR && this.configurationWrapper.messages.ERROR.length > 0;
            },
            errorMessages: function () {
                if (this.errorMessagesExist) {
                    return this.configurationWrapper.messages.ERROR.messages;
                } else {
                    return [];
                }
            },
            messagesExist: function () {
                return this.successMessagesExist || this.needsConfirmationMessagesExist || this.errorMessagesExist;
            }
        }
    }
</script>

<style>

    .card-container .card-information-container {
        padding: 0 0 0 8px;
    }

    .card-container .card-subtitle {
        text-align: left;
    }

    .card-container .card-state-container {
        display: flex;
        align-items: center;
        padding-right: 42px;
    }

    .card-container .card-state-container.NOT_CHECKED {
        color: rgba(0, 0, 0, 0.6);
    }

    .card-container .card-state-container.SUCCESS {
        color: #42b983;
    }

    .card-container .card-state-container.NEEDS_CONFIRMATION {
        color: #e7a34d;
    }

    .card-container .card-state-container.ERROR {
        color: #b00020;
    }

    .feature-review-container .message-container {
        margin-left: 100px;
        padding-top: 25px;
        padding-bottom: 50px;
    }

</style>
